'use client';

import React, { useState } from 'react';
import AppLayout from '@/components/AppLayout';
import { ToastProvider } from '@/components/ui/Toast';
import LeaveDashboardTab from './components/LeaveDashboardTab';
import LeaveApplicationTab from './components/LeaveApplicationTab';
import LeaveApprovedTab from './components/LeaveApprovedTab';
import { LayoutDashboard, FilePlus2, CheckCircle2 } from 'lucide-react';

type TabId = 'dashboard' | 'application' | 'approved';

const tabs: { id: TabId; label: string; icon: React.ReactNode }[] = [
  { id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={15} /> },
  { id: 'application', label: 'Application', icon: <FilePlus2 size={15} /> },
  { id: 'approved', label: 'Approved', icon: <CheckCircle2 size={15} /> },
];

export default function LeavePage() {
  const [activeTab, setActiveTab] = useState<TabId>('dashboard');

  return (
    <ToastProvider>
      <AppLayout>
        <div className="px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-12 py-4 sm:py-6 max-w-screen-2xl mx-auto">
          {/* Page heading */}
          <div className="mb-5">
            <h1 className="text-2xl font-700 text-foreground">Leave Management</h1>
            <p className="text-sm text-muted-foreground mt-0.5">
              Manage employee leave requests, applications, and approvals
            </p>
          </div>

          {/* Tab bar */}
          <div className="flex gap-1 border-b border-border mb-6">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-600 rounded-t-md transition-all duration-150 border-b-2 -mb-px ${
                  activeTab === tab.id
                    ? 'border-primary text-primary bg-primary/5' :'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
              >
                {tab.icon}
                {tab.label}
              </button>
            ))}
          </div>

          {/* Tab content */}
          {activeTab === 'dashboard' && <LeaveDashboardTab />}
          {activeTab === 'application' && <LeaveApplicationTab />}
          {activeTab === 'approved' && <LeaveApprovedTab />}
        </div>
      </AppLayout>
    </ToastProvider>
  );
}
